import { PROPERTY_TYPE_ICON } from 'helpers/icon_helpers';
import type { MapBounds } from '../types';

const MAX_SORT_SQ_MILES = 300;

export const customPropertyMarkerContent = (
  propertyTypeId: number,
  largeIcon: boolean,
  restricted = false,
) => {
  const markerElement = document.createElement('div');
  markerElement.classList.add('property-type-marker');
  
  if (largeIcon) {
    markerElement.classList.add('large');
  }
  
  if (restricted) {
    markerElement.classList.add('property-type-marker-restricted');
  }

  const icon = restricted ?
    'fa-lock' :
    propertyTypeId ? PROPERTY_TYPE_ICON[propertyTypeId] : PROPERTY_TYPE_ICON[0];

  if (largeIcon) {
    markerElement.innerHTML = `
      <div class="d-flex gap-1 align-items-center text-white">
        ${icon ? `<i aria-hidden="true" class="fa-solid ${icon} icon"></i>` : ''}
      </div>
    `;
  }

  markerElement.innerHTML += `<div class="marker-shadow"></div>`;

  return markerElement;
};

export const wideAreaSearch = (bounds: MapBounds) => {
  if (!bounds) {
    return false;
  }

  const north = bounds.north;
  const south = bounds.south;
  const east = bounds.east;
  const west = bounds.west;

  // Approximate miles per degree latitude/longitude
  const milesPerLat = 69.0;
  const milesPerLng =
    69.172 * Math.cos(((north + south) / 2.0) * Math.PI / 180.0);

  const latDiff = Math.abs(north - south);
  const lngDiff = Math.abs(east - west);

  const areaSqMiles = latDiff * milesPerLat * lngDiff * milesPerLng;

  return areaSqMiles > MAX_SORT_SQ_MILES;
};
